import React from "react";
import AdminLayout from "./AdminLayout";
import SaleAgentManagement from "./SaleAgentsManagement"



function SaleAgents() {
    return (
        <AdminLayout>

            <SaleAgentManagement />
        </AdminLayout>
    );
}

export default SaleAgents;
